module.exports = __webpack_public_path__ + "img/about/80243-020.png";


//////////////////
// WEBPACK FOOTER
// ./img/about/80243-020.png
// module id = 17
// module chunks = 0